import { useListVehicles, type ListVehicleResponse } from '../api/listVehicles';
import { useVehicleStore } from 'shared/vehicles/stores/vehicleStore';
import { defineStore } from 'pinia';
import { useRefreshStore } from '@/common/composables/refreshStore';

export const useRefreshVehicleStore = defineStore('refresh-vehicles', () => {
  const listVehicles = useListVehicles();
  const store = useVehicleStore();

  const { initialize, refresh, loading } = useRefreshStore<ListVehicleResponse>({
    fetchFromServer() {
      return listVehicles.execute();
    },
    mergeToStore(response) {
      store.clear();
      store.merge(response.vehicles);
    },
  });

  return {
    initialize,
    refresh,
    loading,
  };
});
